import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const SearchIcon = (props: SvgIconProps) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <circle cx="13.5" cy="13.5" r="10.5" stroke="currentColor" strokeWidth="2" fill="none" />
    <rect x="19.5" y="21.1211" width="2" height="12.1537" transform="rotate(-45 19.5 21.1211)" fill="currentColor" />
  </SvgIcon>
)

export default SearchIcon
